import React, { Component } from 'react';
import { connect } from 'react-redux';
import { firebase } from '../firebase';
import { Button, FormGroup, FormControl } from 'react-bootstrap';
import 'react-block-ui/style.css';
import swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import withAuthorization from '../session/with_authorization';
import Navigation from '../components/header/Navigation';
import { fetchTemplate } from '../redux/actions/app-actions';
import axios from 'axios';
import { default as config } from '../constants/constants';

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value
});

class EmailTemplatePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      htmlCode: ''
    };
  }

  componentWillMount() {
    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        this.props.dispatch(fetchTemplate(token));
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.template && this.props.template !== nextProps.template) {
      this.setState({ htmlCode: nextProps.template });
    }
  }

  testEmail = (event) => {
    const { htmlCode } = this.state;

    firebase.auth.currentUser.getIdToken().then((token) => {
      const options = {
        method: 'PUT',
        headers: { 'X-Firebase-Auth': token, 'content-type': 'text/html' },
        url: `${config.serverURL}/templates/testEmail`,
        data: htmlCode
      };

      axios(options)
        .then(function() {
          swal({
            imageUrl: logo,
            title: `<div class="titleModal">An email was sent to your email inbox.</div>`,
            html: '<p class="contentModal">Please check the changes.</p>',
            showConfirmButton: false,
            showCloseButton: true,
            background: '#121C24',
            allowOutsideClick: false
          });
        })
        .catch(function() {
          swal({
            imageUrl: logo,
            title: `<div class="titleModal">There was an error sending the email.</div>`,
            html: '<p class="contentModal">Please try again later.</p>',
            showConfirmButton: false,
            showCloseButton: true,
            background: '#121C24',
            allowOutsideClick: false
          });
        });
    });

    event.preventDefault();
  };

  handleSubmit = (event) => {
    const { htmlCode } = this.state;

    firebase.auth.currentUser.getIdToken().then((token) => {
      const options = {
        method: 'PUT',
        headers: { 'X-Firebase-Auth': token, 'content-type': 'text/html' },
        url: `${config.serverURL}/templates`,
        data: htmlCode
      };

      axios(options)
        .then(function() {
          swal({
            imageUrl: logo,
            title: `<div class="titleModal">The new template is now available.</div>`,
            html: '<p class="contentModal"></p>',
            showConfirmButton: false,
            showCloseButton: true,
            background: '#121C24',
            allowOutsideClick: false
          });
        })
        .catch(function() {
          swal({
            imageUrl: logo,
            title: `<div class="titleModal">There was an error updating the template.</div>`,
            html: '<p class="contentModal">Please try again later.</p>',
            showConfirmButton: false,
            showCloseButton: true,
            background: '#121C24',
            allowOutsideClick: false
          });
        });
    });
    event.preventDefault();
  };

  render() {
    const { htmlCode } = this.state;

    const isInvalid = htmlCode === '';

    return (
      <div>
        <Navigation />
        <div className="main-page">
          <div className="rounded-container">
            <div
              className="headerDivDesc"
              style={{ textAlign: 'center', marginBottom: '55px' }}
            >
              Email Template
            </div>
            <form>
              <FormGroup controlId="htmlCode" className="email-template">
                <FormControl
                  componentClass="textarea"
                  placeholder="Html code"
                  type="text"
                  value={this.state.htmlCode}
                  rows="30"
                  onChange={(event) =>
                    this.setState(byPropKey('htmlCode', event.target.value))
                  }
                />
              </FormGroup>
            </form>
          </div>
          <div style={{ textAlign: 'center', paddingTop: '600px' }}>
            <Button
              disabled={isInvalid}
              style={{ marginRight: 5 }}
              type="submit"
              className="email-button btn-general"
              onClick={this.testEmail.bind(this)}
            >
              Test
            </Button>
            <Button
              disabled={isInvalid}
              style={{ marginRight: 0 }}
              type="submit"
              className="email-button btn-general"
              onClick={this.handleSubmit.bind(this)}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    braintreeToken: store.user.braintreeToken,
    template: store.app.template
  };
};

const authCondition = (authUser) => !!authUser && authUser.isAdmin;

export default withAuthorization(authCondition)(
  connect(mapStateToProps)(EmailTemplatePage)
);
